module.exports = __webpack_public_path__ + "img/75658.3dc00a6c.svg";